/**
 * @file Footer.js
 * @author Stanley Chen
 * @description Footer component that appears at the bottom of every page with
 * navigation links, business hours, social media connections, and a map
 */

import React from 'react';
import { Link } from 'react-router-dom';
import OutboundLink from '../OutboundLink';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-main">

                    <div className="footer-nav">
                        <Link to="/menu" className="footer-link">MENU</Link>
                        <OutboundLink 
                            href="https://kikude.kwickmenu.com/" 
                            className="footer-link"
                            label="Online Ordering - Pickup (Footer)"
                        >
                            ORDER PICKUP
                        </OutboundLink>
                        <OutboundLink 
                            href="https://www.doordash.com/store/kiku-japanese-steakhouse-&-sushi-bar-middletown-579754/1499137/" 
                            className="footer-link"
                            label="Online Ordering - DoorDash (Footer)"
                        >
                            ORDER DOORDASH
                        </OutboundLink>
                        <Link to="/#about" className="footer-link">ABOUT US</Link>
                        <Link to="/contact" className="footer-link">CONTACT US</Link>
                    </div>

                    <div className="footer-hours">
                        <h3>HOURS</h3>
                        <p>Fri, Sat:<br />11:30 AM - 10:00 PM</p>
                        <p>Sun, Mon, Tue, Wed, Thur:<br />11:30 AM - 9:30 PM</p>

                        <h3 className="connect-heading">CONNECT WITH US</h3>
                        <div className="social-icons">
                            <OutboundLink 
                                href="https://www.facebook.com/KikuMiddletown/" 
                                className="social-icon" 
                                aria-label="Facebook"
                                label="Facebook (Footer)"
                            >
                                <i className="fab fa-facebook"></i>
                            </OutboundLink>
                            <OutboundLink 
                                href="https://www.yelp.com/biz/kiku-middletown-2?utm_campaign=www_business_share_popup&utm_medium=copy_link&utm_source=(direct)" 
                                className="social-icon" 
                                aria-label="Yelp"
                                label="Yelp (Footer)"
                            >
                                <i className="fab fa-yelp"></i>
                            </OutboundLink>
                        </div>
                    </div>

                    <div className="footer-map">
                        <div className="map-container">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3080.9362876307396!2d-75.7354203243709!3d39.448172014019235!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c7a06b0c7d482d%3A0xebd6e4e32be7c5f1!2sKiku%20Japanese%20Steakhouse%20%26%20Sushi%20Bar!5e0!3m2!1sen!2sus!4v1745631403407!5m2!1sen!2sus"
                                width="425"
                                height="350"
                                style={{ border: '0' }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Map of Kiku location"
                            ></iframe>
                            <small>
                                <OutboundLink
                                    href="https://www.google.com/maps?q=39.448172014019235,-75.7354203243709&hl=en"
                                    label="Google Maps (Footer)"
                                >
                                    View Larger Map
                                </OutboundLink>
                            </small>
                        </div>
                        <p className="address">417 S Ridge Ave Middletown, DE 19709</p>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="copyright">
                        <p>© 2025 Kiku Japanese Steakhouse | Website Designed and Coded by Stanley Chen</p>
                    </div>
                    <div className="footer-legal">
                        <Link to="/accessibility-standards" >Accessibility Standards</Link> | <Link to="/terms-and-conditions" >Terms and Conditions</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;